import { extendTheme } from "@chakra-ui/react";

const theme = () =>
  extendTheme({
    colors: {
      basic: {
        500: "#688FFB",
        600: "#1B53F0",
        700: "#0B34A7"
      },
      blue: {
        500: "#688FFB",
        600: "#1B53F0",
        700: "#0B34A7"
      },
      minor: {
        500: "#718096",
        600: "#4A5568",
        700: "#2D3748"
      },
      dark: {
        500: "#313143"
      },
      trout: {
        500: "#4D4E67"
      },
      light: {
        500: "#CFDAFB"
      }
    },
    fonts: {
      heading: `'Inter', sans-serif`,
      body: `'Inter', sans-serif`
    },
    components: {
      Button: {
        defaultProps: {
          colorScheme: "basic"
        }
      },
      Input: {
        baseStyle: {
          field: {
            _placeholder: {
              color: "gray.400"
            }
          }
        }
      },
      NumberInput: {
        baseStyle: {
          field: {
            _placeholder: {
              color: "gray.400"
            }
          }
        }
      },
      Textarea: {
        baseStyle: {
          _placeholder: {
            color: "gray.400"
          }
        }
      },
      Checkbox: {
        defaultProps: {
          colorScheme: "dark"
        },
        baseStyle: {
          control: {
            borderRadius: "50%"
          }
        }
      },
      Radio: {
        defaultProps: {
          colorScheme: "dark"
        },
        baseStyle: {
          label: {
            ml: 4
          }
        }
      },
      Tabs: {
        baseStyle: {
          tab: {
            _selected: {
              outline: "none"
            }
          }
        }
      },
      Switch: {
        defaultProps: {
          colorScheme: "trout"
        }
      },
      Alert: {
        variants: {
          basic: {
            container: {
              bg: "#E7ECFD",
              color: "basic.700",
              p: "4"
            },
            title: {
              mb: "1.5"
            },
            icon: {
              width: 0,
              m: 0
            }
          }
        }
      }
    },
    breakpoints: {
      md: "48.1em"
    }
  });

export default theme;
